import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useSelector } from "react-redux";

const BankListContext = createContext();

const BankListProvidor = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const [banklist, setBankList] = useState([]);
  const [aepsloading, setLoading] = useState(true);

  const fetchBankList = async () => {
    try {
      const response = await axiosInstance.get("/api/aeps/bank-list");

      const banks =
        response?.data?.banklist ||
        response?.data?.data?.banklist ||
        [];

      if (banks.length > 0) {
        setBankList(banks);
        localStorage.setItem("aeps_bank_list", JSON.stringify(banks));
      }
    } catch (error) {
      console.error("Bank API failed, loading from cache");

      const cached = localStorage.getItem("aeps_bank_list");
      if (cached) {
        setBankList(JSON.parse(cached));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const cached = localStorage.getItem("aeps_bank_list");
    if (cached) {
      setBankList(JSON.parse(cached));
      setLoading(false);
    } else if (userInfo) {
      fetchBankList();
    }
  }, [userInfo]);

  return (
    <BankListContext.Provider value={{ banklist, aepsloading }}>
      {children}
    </BankListContext.Provider>
  );
};

const useBankList = () => useContext(BankListContext);

export { BankListProvidor, useBankList };
